import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics, categories } from '@/mocks/comics';

export default function RankingSection() {
  const sorted = [...comics].sort((a, b) => b.views - a.views).slice(0, 8);

  return (
    <section className="py-8 md:py-10 bg-background-100" aria-labelledby="ranking-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 id="ranking-title" className="text-lg md:text-xl font-heading text-foreground-900">
            人气排行榜
          </h2>
          <Link to="/category/shaonian" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            查看更多 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-4">
          {sorted.map((comic, index) => {
            const cat = categories.find((c) => c.slug === comic.category);
            return (
              <div key={comic.id} className="relative">
                {index < 3 && (
                  <div className="absolute -top-2 -left-2 z-10 w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white bg-accent-500">
                    {index + 1}
                  </div>
                )}
                <ComicCard
                  slug={comic.slug}
                  title={comic.title}
                  author={comic.author}
                  cover={comic.cover}
                  category={comic.category}
                  categoryName={cat?.name || ''}
                  status={comic.status}
                  rating={comic.rating}
                  views={comic.views}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}